// extracted by css-extract-rspack-plugin
export default {"section":"QgGn1C","activities":"oCDt7l","empty-state":"KVlCfv","emptyState":"KVlCfv"};